export default class PipiPupuAuth extends EventTarget {
	constructor() {
		super();
		this.username = null;
		this.token = null;
	}

	loadFromLocalStorage() {
		return this.loadToken(localStorage.getItem('authToken'));
	}

	store(token) {
		localStorage.setItem('authToken', token);
	}

	load(token) {
		this.store(token);
		this.loadToken(token);
	}

	setToken(data) {
		this.token = data;
		this.dispatchEvent(new CustomEvent('authChanged', { detail: { isLoggedIn: this.isLoggedIn(), isSubUser: !!localStorage.getItem('oldToken') }}));
	}

	pushToken(token) {
		localStorage.setItem('oldToken', localStorage.getItem('authToken'));
		this.load(token);
	}

	popToken() {
		const oldToken = localStorage.getItem('oldToken');
		localStorage.removeItem('oldToken');
		this.load(oldToken);
	}

	loadToken(token) {
		if(!token) return this.setToken(null);
		try {
			const split = token.split('.');
			const b64decode = s => window.atob(s.replace(/-/g, '+').replace(/_/g, '/'));
			this.setToken({
				raw: token,
				header: JSON.parse(b64decode(split[0])),
				payload: JSON.parse(b64decode(split[1])),
			});
		} catch(e) {
			localStorage.removeItem('authToken');
			this.setToken(null);
		}
	}

	isLoggedIn() { return !!this.token; }
}
